/**
 * The client's presence ping while a turn is parked on the user (#540) — and, since I198
 * review round 6, the way an open tab learns that a SUSPENDED turn became ready to resume.
 *
 * A question answered during a worker shutdown can be carried into the suspension row
 * by the WORKER (the reply route's own row check ran before the row existed, so it
 * answered a plain 200 with no `resumeReady`). The tab then still sits in
 * `awaiting_answer` — a suspended turn never gets a terminal frame — and keeps pinging
 * `/pending`, whose durable fallback reports `resumeReady` once every parked request of
 * the turn is answered. Acting on it starts the resume, exactly as a `resumeReady` reply
 * does; without it the answered turn sat until a reload, and a "continue" typed
 * meanwhile superseded it (the 200'd answer then resolved "not performed").
 *
 * `onResumeReady` fires at most once per ping loop (one per status); errors are ignored.
 */
export function createAwaitingPing(opts: {
  fetchPending: () => Promise<{ resumeReady?: boolean } | null | undefined>
  onResumeReady: () => void
}): () => Promise<void> {
  let started = false
  return async () => {
    try {
      const res = await opts.fetchPending()
      if (res?.resumeReady && !started) {
        started = true
        opts.onResumeReady()
      }
    } catch { /* a ping is best-effort */ }
  }
}
